// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oNEJg","colBig":"styles_colBig__2zG5u","colSmall":"styles_colSmall__Ue55k"};